export default class TypeResidencyStatus {
  id!: number
  residency_status!: string
  isEdit!: boolean
}
